var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUnlink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#unlink_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 3h-1V1h1zM5 13H4v2h1zM15 3h-2v1h2zM3 12H1v1h2zm10-5.95v1a2.5 2.5 0 0 1-.5 4.95h-4A2.5 2.5 0 0 1 8 7.051v-1A3.492 3.492 0 0 0 8.5 13h4a3.492 3.492 0 0 0 .5-6.95M7.5 3h-4A3.492 3.492 0 0 0 3 9.95v-1A2.5 2.5 0 0 1 3.5 4h4A2.5 2.5 0 0 1 8 8.949v1A3.492 3.492 0 0 0 7.5 3"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "unlink_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgUnlink;